module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.7aefb8fef9f6630decfb.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.eot
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.eot
// module chunks = styles